/* src/app/components/indicator-sectors/indicator-sectors.component.css */
/*# sourceMappingURL=indicator-sectors.component.css.map */
